import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './InstallationSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { useNavigate } from 'react-router-dom';

const InstallationSection = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation({ once: true });
    const navigate = useNavigate();

    const installationItems = [
        {
            imgSrc: `${process.env.PUBLIC_URL}/images/gg-hardware-cereal-combine-installation-diagram.png`,
            altKey: 'installation.alt_text_cereals',
            subtitleKey: 'installation.subtitle_cereals',
            interest: 'cereal_sensors',
            learnMoreLabel: t('installation.learnMoreCereals')
        },
        {
            imgSrc: `${process.env.PUBLIC_URL}/images/potato-scheme-installation.png`,
            altKey: 'installation.alt_text_potato',
            subtitleKey: 'installation.subtitle_bulk_crops',
            interest: 'potato_sensors',
            learnMoreLabel: t('installation.learnMorePotato')
        }
    ];

    const handleLearnMore = (interest) => {
        const targetId = 'cta-form';
        navigate(`/#${targetId}?interest=${interest}`, { replace: false });
        setTimeout(() => {
            const el = document.getElementById(targetId);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        }, 0);
    };

    return (
        <section 
            id="installation" 
            className={`${styles.installationSection} animate-on-scroll`}
            ref={sectionRef}
        >
            <div className="container">
                <h2 className={`section-title ${styles.sectionTitle}`}>
                    {t('installation.title_line1')}<br />{t('installation.title_line2')}
                </h2>
                <div className={styles.installationGallery}>
                    {installationItems.map((item, index) => (
                        <figure 
                            className={styles.installationItem}
                            key={index}
                        >
                            <div className={styles.imageWrapper}>
                                <picture>
                                    <source srcSet={item.imgSrc.replace(/\.png$/, '.webp')} type="image/webp" />
                                    <img 
                                        src={item.imgSrc} 
                                        alt={t(item.altKey)}
                                        className={styles.installationImage}
                                        loading="lazy"
                                    />
                                </picture>
                            </div>
                            <figcaption className={styles.installationCaption}>{t(item.subtitleKey)}</figcaption>
                            <div className={styles.buttonWrapper}>
                                <button 
                                    className={`btn btn-primary ${styles.learnMoreBtn}`}
                                    onClick={() => handleLearnMore(item.interest)}
                                >
                                    {item.learnMoreLabel}
                                </button>
                            </div>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default InstallationSection;
